<template>

    <Modal :value="value" @input="closeModal">
      <h1 v-if="managerLabels" slot="header">
        <ArrowLeftIcon class="icon" @click="toChoiceLabels()"/> Gerenciar Marcadores
      </h1>
      <h1 v-else slot="header">Marcadores</h1>

      <div v-if="loadLabels" class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <h5>Carregando</h5>
          </div>
        </div>
      </div>

      <div v-else-if="managerLabels" class="container">
        <div class="row">
          <div class="col-md-4">

            <h5>Criar novo marcador</h5>

            <div class="form-group">
              <label for="name-label">Nome</label>
              <input id="name-label" type="text" v-model="label.name" class="form-control">
            </div>

            <div class="form-group">
              <label>Cor</label>
              <div class="form-control color-options">
                <div class="color-option" v-for="obj in colorOptions"
                     :style="{ background: obj.color }"
                     :class="{ 'color-option-selected': obj.selected }"
                     :key="obj.color" :title="obj.title" @click="setColor(obj)"/>
              </div>
            </div>

            <div class="form-group mt-3">
              <button @click="clearLabel()" class="btn btn-outline mr-1">Limpar</button>
              <button @click="save()" :disabled="buttonDisabledSave" class="btn btn-success">Salvar</button>
            </div>

          </div>

          <div class="col-md-8 container-labels">

            <table class="table table-align">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Cor</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="label in labels" :key="label.id">
                  <td>{{ label.name }}</td>
                  <td>
                    <div class="color-option" :style="{ background: label.color, cursor: 'default' }"/>
                  </td>
                  <td>
                    <button class="btn btn-sm btn-outline" @click="setEdit(label)">Editar</button>
                    <button class="btn btn-sm btn-outline-red ml-1" @click="deleteLabel(label)">Excluir</button>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>

      <div v-else-if="labels.length === 0" class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <h3>Não existem marcadores para este recursos</h3>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12 text-center">
            <button @click="toManagerLabels()" class="btn btn-outline">Gerenciar Marcadores</button>
          </div>
        </div>

      </div>

      <div v-else class="container">
        <div class="row">
          <div class="col-md-12">

            <label for="label">Selecione um marcador</label>
            <select id="label" v-model="label" class="form-control">
              <option :value="l" v-for="l in labels" :key="l.id" style="" :title="colorPtBR(l.color)">
                {{ l.name }} - ({{ colorPtBR(l.color) }})
              </option>
            </select>

          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12">
            <button class="btn btn-success" @click="setResources()" :disabled="!(label && label.id)">Aplicar</button>
            <button class="btn btn-outline-red ml-1" @click="defaultRemoveLabels(app, className, resources)">Remover Marcadores</button>
            <button @click="toManagerLabels()" class="btn btn-outline float-right">Gerenciar Marcadores</button>
          </div>
        </div>

      </div>

    </Modal>

</template>

<script>
  import Modal from './specialTag/Modal'
  import ModelMapper from '@/mixins/ModelMapper'
  import { ArrowLeftIcon } from 'vue-feather-icons'
  import RemoveLabel from '@/mixins/RemoveLabel'

  export default {
    components: { ArrowLeftIcon, Modal },
    computed: {
      buttonDisabledSave() {
        return !(this.label && this.label.color && this.label.name)
      },
      labels() {
        return this.getModels || []
      }
    },
    created() {
      this.params.perPage = 1000
      this.query.app = this.app
      this.order.name = 'asc'

      this.resources.forEach(r => {
        if (!('label' in r))
          this.$set(r, 'label', null)
      })

      this.asyncTemplateSelect({
        after: () => {
          if (this.labels.length > 0)
            this.label = this.labels[0]
          this.loadLabels = false
        }
      })
    },
    data() {
      return {
        colorOptions: [
          { color: 'green', selected: false, title: 'Verde' },
          { color: 'yellow', selected: false, title: 'Amarelo' },
          { color: 'orange', selected: false, title: 'Laranja' },
          { color: 'red', selected: false, title: 'Vermelho' },
          { color: 'purple', selected: false, title: 'Roxo' },
          { color: 'blue', selected: false, title: 'Azul' },
          { color: 'black', selected: false, title: 'Preto' },
        ],
        label: {},
        loadLabels: true,
        managerLabels: false,
        nameModel: 'Label'
      }
    },
    methods: {
      clearLabel() {
        this.label = {}
        this.$set(this.label, 'name', '')
        this.$set(this.label, 'color', '')
        this.$set(this.label, 'app', this.app)
      },
      closeModal() {
        this.$emit('input', false)
        this.managerLabels = false
      },
      colorPtBR(color) {
        const result = this.colorOptions.find(c => c.color === color)
        return (result && result.title) || ''
      },
      deleteLabel(label) {
        if (!confirm('Tem certeza?\nTodos os itens associado a este marcador serão desmarcados.'))
          return

        this.asyncTemplateDelete(label, {
          after: () => {
            this.$notify.add('Marcador excluído com sucesso!')
            this.find()
            this.$emit('deleteLabel', label)
          }
        })
      },
      find() {
        this.asyncTemplateSelect()
      },
      save() {
        this.asyncTemplateSave(this.label, {
          after: () => {
            this.clearLabel()
            this.find()
            this.colorOptions.forEach(o => o.selected = false)
          }
        })
      },
      setColor(obj) {
        this.colorOptions.forEach(o => o.selected = false)
        obj.selected = true
        this.label.color = obj.color
      },
      setEdit(label) {
        this.label = {...label}
      },
      setResources() {
        const data = {
          resources: this.resources.filter(r => r.checked).map(r => ({
            class_name: r.className,
            id: r.id,
            label_id: this.label.id
          }))
        }
        
        this.openLoad()
        this.axios.put('labels/bind_resources', data)
          .then(() => this.resources.forEach(r => r.label = this.label))
          .then(() => this.$notify.add('Atualizado'))
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeLoad())

      },
      toChoiceLabels() {
        this.managerLabels = false
        this.label = this.labels[0]
      },
      toManagerLabels() {
        this.clearLabel()
        this.managerLabels = true
      }
    },
    mixins: [ModelMapper, RemoveLabel],
    name: 'BkpsLabel',
    props: {
      app: { required: true, type: String },
      className: { type: String },
			resources: { required: true, type: Array },
      value: { default: false, type: Boolean },
    },
    watch: {
      resources(value) {
        if (value.length === 0)
          this.closeModal()
      }
    }
  }
</script>

<style scoped>

  .icon {
    cursor: pointer;
  }

  .color-options {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
  }

  .color-option {
    height: 16px;
    width: 16px;
    border-radius: 8px;
    cursor: pointer;
  }

  .color-option-selected {
    border: 1px solid #8A9EB5;
    box-shadow: 1px 1px 10px 5px gray;
  }

  .container-labels {
    height: 400px;
    overflow-y: auto;
  }
</style>
